import { use } from "react";
import { ActionNames } from "../@types/enums";
import { Role } from "../@types/roles";
import { canPerformAction } from "../_helpers/permissions";
import { usePermissionsContext } from "./usePermissionsContext";
import { useUserContext } from "./useUserContext";

const useCanPerformAction = (): ((actionName: ActionNames) => boolean) => {
  const permissions = usePermissionsContext();
  const user = useUserContext();
  return (actionName: ActionNames) => {
    return canPerformAction(actionName, user.details.role, permissions);
  };
};

export default useCanPerformAction;
